{
  "dashboard": {
    "column": {
      "title": "Titel",
      "todo": "Att göra"
    },
    "header": "Kontrollpanel",
    "myTodos": {
      "title": "Mina uppgifter",
      "itemsCount": "{{count}} uppgifter",
      "empty": "Inga uppgifter just nu",
      "tooltips": {
        "reviewStep": "Du har ett dokument att granska",
        "approveStep": "Du har ett dokument att godkänna",
        "publishDocument": "Arbetsflöde klart, redo att publicera",
        "rejectedStepByUser": "{{name}} avvisade ett steg i arbetsflödet",
        "rejectedStepByYou": "Du avvisade ett steg i arbetsflödet",
        "rejectedStepFallback": "Ett steg i arbetsflödet avvisades",
        "moveForward": "Steg klart, nästa steg kan aktiveras",
        "readDocument": "Du har ett dokument att läsa"
      },
      "dateLabels": {
        "published": "Publicerad",
        "adopted": "Beslutad",
        "date": "Datum",
        "stepDueAt": "Stegets svarsdatum",
        "documentVersionReviewTo": "Arbetsflödets slutdatum"
      }
    },
    "ongoing": {
      "workflows": "Pågående arbetsflöden"
    },
    "publish": {
      "title": "Förankring"
    },
    "upcoming": {
      "workflows": "Kommande arbetsflöden"
    },
    "createDocument": {
      "uploadFile": "Ladda upp fil",
      "file": "Fil",
      "fileType": "Typ",
      "fileTypeDescription": "Vänligen notera att redigering av Office-dokument kräver en aktiv Microsoft 365-licens",
      "supportedFormats": "Filformat som stöds:",
      "errorCreating": "Fel vid skapande av dokument"
    },
    "userManual": {
      "getStarted": "Kom igång med North House genom att läsa",
      "userGuide": "Användarguiden"
    }
  }
}
